import React, { useEffect, useState } from 'react';
import httpCommon from '../../../http-common';
import { Box, IconButton, Input, Switch } from '@mui/material';
import { CustomDataGrid } from '../../../common/components/Table/CustomDataGrid';
import CustomExportButton from '../../../common/components/Table/CustomExportButton';
import { Delete as DeleteIcon } from '@mui/icons-material';
import { useGridApiRef } from '@mui/x-data-grid';
import { v4 } from "uuid";
import ContainedButton from '../../../common/components/Buttons/ContainedButton';
import SnackbarWithMessage from '../../../common/components/Snackbars/SnackbarWithMessage';
import { FileUploaderRipik } from '../../HomePage/components/FileUploaderRipik';
import { mixpanelTrackTabsButton } from '../../../mixPanelFunctions/mixPanelFunctions';

const postTestDescription = async (test_data) => {
  const data = JSON.stringify({ ...test_data });
  try {
    const response = await httpCommon.post(`/v1/qc/test_description`, data);
    const result = response.data;
    if (result?.status === "success") return true;
    else throw new Error(`${result.message}`);
  } catch (error) {
    console.log({ error });
    return error;
    // return ;
  }
};

const deleteTestDescription = async (test_description_body) => {
  const data = JSON.stringify({ ...test_description_body });
  try {
    const response = await httpCommon.delete(`/v1/qc/test_description`, { data });
    const result = response.data;
    if (result?.status === "success") return true;
    else throw new Error(`Test Description couldn't be deleted, response message:${result.message}`);
  } catch (error) {
    console.log({ error });
    return error;
  }
};

const TestDescriptionCell = ({ value, id, handle_change, type = "text" }) => {
  return <Input
    // sx={{ width: "100%" }}
    value={value}
    id={id}
    onChange={(e) => {
      handle_change(e);
    }}
    onKeyDown={(e) => {
      e.stopPropagation();
    }}
    type={type} />;
};

const TestDescriptionDashboard = () => {
  const [rows, set_rows] = useState([]);

  const fetch_data = async () => {
    try {
      const response = await httpCommon.get(`/v1/qc/test_description`);
      const result = response.data.data.map((item) => ({
        ...item,
        id: item._id
      }));
      return result;
    } catch (error) {
      console.log({ error });
    }
  };

  const initialize_data = async () => {
    const data = await fetch_data();
    set_rows(data);
  };

  const apiRef = useGridApiRef();

  const handleDeleteTestDesscription = async (params) => {
    // console.log({ params });
    const {
      "Test ID": test_id
    } = params.row;
    const response = await deleteTestDescription({
      test_id
    });
    if (response === true) {
      const row_id = params.row.id;
      apiRef.current.updateRows([{
        id: row_id,
        // _action: "delete"
        is_disabled: !params?.row?.is_disabled
      }]);
    }
    else {
      console.log("probably this SLA doesn't exist, reloading the data for you.");
      initialize_data();
    }
  };
  const columns = [
    {
      field: "Test ID",
      headerName: "Test ID",
      flex: 1,
      editable: true
    },
    {
      field: "Num max batches",
      headerName: "Num max batches",
      flex: 1,
      editable: true
    },
    {
      field: "Test type",
      headerName: "Test type",
      flex: 1,
      editable: true
    },
    {
      field: "Machine Required",
      headerName: "Machine Required",
      flex: 1,
      editable: true,
      type: "singleSelect",
      valueOptions: [
        { label: "N", value: "N" },
        { label: "Y", value: "Y" },
      ]
    },
    {
      field: "Machine Abbrevation",
      headerName: "Machine Abbrevation",
      flex: 1,
      editable: true
    },
    {
      field: 'is_disabled',
      headerName: 'Enable',
      width: 100,
      renderCell: (params) => {
        // console.log({ params });
        return (
          <Box sx={{ width: "100%" }}>
            <div style={{ position: 'sticky', right: 0, zIndex: 1 }}>
              <Switch checked={!params?.row?.is_disabled} onClick={() => {
                handleDeleteTestDesscription(params);
              }} />
              {/* <IconButton onClick={() => handleDeleteTestDesscription(params)}>
                <DeleteIcon style={{ color: '#ff5722' }} />
              </IconButton> */}
            </div>
          </Box>
        );
      },
    },
  ];

  useEffect(() => {
    initialize_data();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const saveOnServer = async (updatedRow) => {
    const { _id, "Test ID": test_id, ...update_fields } = updatedRow;

    const data = JSON.stringify({
      test_id,
      update_fields
    });
    const response = await httpCommon.patch(`/v1/qc/test_description`, data);
    const result = response.data.status;
    if (result === "success") return true;
    else return false;
  };

  const [new_dg_row, set_new_dg_row] = useState([{
    id: v4(),
    "Test ID": "",
    "Num max batches": "",
    "Test type": "",
    "Machine Required": "",
    "Machine Abbrevation": "",
  }]);

  const handle_change_new_row_data = (e) => {
    const { id, value } = e.target;
    const old = { ...new_dg_row[0] };
    old[id] = value;
    set_new_dg_row([{ ...old }]);
  };

  const new_dg_columns = [
    {
      field: "Test ID",
      headerName: "Test ID",
      flex: 1,
      editable: false,
      renderCell: () => {
        return <TestDescriptionCell value={new_dg_row[0]['Test ID']} handle_change={handle_change_new_row_data} id={"Test ID"} />;
      },
    },
    {
      field: "Num max batches",
      headerName: "Num max batches",
      flex: 1,
      editable: false,
      renderCell: () => {
        return <TestDescriptionCell value={new_dg_row[0]['Num max batches']} handle_change={handle_change_new_row_data} id={"Num max batches"} />;
      },
    },
    {
      field: "Test type",
      headerName: "Test type",
      flex: 1,
      editable: false,
      renderCell: () => {
        return <TestDescriptionCell value={new_dg_row[0]['Test type']} handle_change={handle_change_new_row_data} id={"Test type"} />;
      },
    },
    {
      field: "Machine Required",
      headerName: "Machine Required",
      flex: 1,
      editable: false,
      renderCell: () => {
        return <TestDescriptionCell value={new_dg_row[0]['Machine Required']} handle_change={handle_change_new_row_data} id={"Machine Required"} />;
      },
    },
    {
      field: "Machine Abbrevation",
      headerName: "Machine Abbrevation",
      flex: 1,
      editable: false,
      renderCell: () => {
        return <TestDescriptionCell value={new_dg_row[0]['Machine Abbrevation']} handle_change={handle_change_new_row_data} id={"Machine Abbrevation"} />;
      },
    },
    {
      "field": "add_row",
      "headerName": "",
      "editable": false,
      renderCell: () => {
        const handle_add = async () => {
          const row = new_dg_row[0];
          const vals = Object.values(row);
          for (let val of vals) {
            if (val === "" || val === null) {
              alert("Please enter all the fields before adding the Test Description Data.");
              return;
            }
          }
          const {
            id,
            "Test ID": test_id,
            ...rest
          } = row;
          const sla_data = { test_id, add_fields: { ...rest } };
          const response = await postTestDescription(sla_data);
          if (response === true) {
            apiRef.current.updateRows([{ ...row }]);
            set_new_dg_row(prev => ([{
              ...prev[0],
              sample_type: "",
              SLA: "",
              id: v4()
            }]));
            // alert("updated");
          }
          else {
            // alert("couldn't update due to some error at the backend.");
            alert(response);
          }
        };
        return <ContainedButton handleClick={handle_add}>Add</ContainedButton>;
      }
    }
  ];

  const [open_snackbar_with_message, set_open_snackbar_with_message] = useState({
    open: false,
    message: "",
    severity: "info"
  });

  const [file, set_file] = useState(null);

  const handle_file_upload = async (uploaded_file) => {
    try {
      const data = new FormData();
      data.append("excel_file", uploaded_file);
      // console.log([...data.entries()]);
      const response = await httpCommon.post(`/v1/qc/upload_mastersheet/test_description/`, data, {
        "headers": {
          "Content-Type": "multipart/form-data"
        }
      });
      const result = response.data;
      mixpanelTrackTabsButton("TestDescriptionDashboard","file upload","master-sheet") // tracking tab button
      console.log({ result });
      if (result.status === "error") {
        set_open_snackbar_with_message({
          message: result.message,
          open: true,
          severity: "error"
        });
      }
      else if (result.status === "success") {
        set_open_snackbar_with_message({
          message: `Data uploaded successfully!`,
          open: true,
          severity: "success"
        });
        initialize_data();
      }
    } catch (error) {
      console.log({ error });
    }
  };

  return (
    <Box>
      <Box className="mb-4">
        <SnackbarWithMessage {...open_snackbar_with_message} onClose={() => {
          set_open_snackbar_with_message({
            open: false,
            message: "",
            severity: "info"
          });
        }} />
        <Box className="flex justify-end items-center">
          <FileUploaderRipik file={file} file_update_function={(uploaded_file) => {
            set_file(uploaded_file);
            console.log(uploaded_file);
            handle_file_upload(uploaded_file);
          }} upload_message={`Upload File Here`} />
        </Box>
        <CustomDataGrid
          apiRef={apiRef}
          columns={columns}
          rows={rows}
          sx={{
            height: "500px",
            "& .MuiDataGrid-row": {
              '&:hover': {
                // cursor: "cell",
                // backgroundColor: "#F5F5F5",
              }
            },
          }}
          slots={{
            toolbar: CustomExportButton
          }}
          hideFooter
          hideFooterSelectedRowCount
          disableRowSelectionOnClick
          processRowUpdate={async (updatedRow, originalRow) => {
            const result = await saveOnServer(updatedRow);
            if (result) return updatedRow;
            else return originalRow;
            // console.log({ updatedRow, originalRow });
            // return updatedRow;
          }}
        />
      </Box>
      <Box>
        <CustomDataGrid
          columns={new_dg_columns}
          rows={new_dg_row}
          hideFooter
        />
      </Box>
    </Box>
  );
};

export default TestDescriptionDashboard;